
import { Component, Vue } from 'vue-property-decorator'
import LogoFooter from './LogoFooter.vue'
import CopyrightFooter from './CopyrightFooter.vue'

@Component({
  name: 'MiniFooter',
  components: {
    LogoFooter,
    CopyrightFooter
  }
})
export default class MiniFooter extends Vue {
  get links() {
    return [
      { href: '/privacy', text: 'Privacy Policy', id: 1, target: '_blank' },
      { href: '/privacy-california', text: 'CA Privacy Notice', id: 2, target: '_blank' },
      { href: '/opt-out', text: 'Limit Use Of My Sensitive Personal Information', id: 3, target: '_blank' }
    ]
  }
}
